import React, {useState} from 'react';
import './index.css';

const NoticeBoard001 = () => {
  // 理論上這邊之後應該會串後端 拿資料, 這邊demo先這樣寫
  const [enteryType, setEnteryType] = useState([
    {leftInfo:'恭喜玩家user******01', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******02', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******03', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******04', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******05', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******06', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******07', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******08', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******09', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******10', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******11', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******12', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******13', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******14', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******15', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******16', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******17', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******18', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******19', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******20', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******21', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******22', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******23', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******24', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******25', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******26', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******27', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******28', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******29', rightInfo: '获得奖金10475.65'},
    {leftInfo:'恭喜玩家user******30', rightInfo: '获得奖金10475.65'},
  ])
  const Add = enteryType.map(Add => Add) || setEnteryType.map(Add => Add)
  return(
    <div className="noticeBoard001"><div className="noticeBoardBox">{Add.map((enteryType, key) => <div key={key} className="noticeBoardInBox"><p>{enteryType.leftInfo}<span>{enteryType.rightInfo}</span></p></div>)}</div></div>
  )
}

export default NoticeBoard001
